import frame6Svg from '@listening/assets/astro/images/Frame-6.svg';
import frame7Svg from '@listening/assets/astro/images/Frame-7.svg';
import frame1362789762Png from '@listening/assets/astro/images/Frame-1362789762.png';
import layoutRightSvg from '@listening/assets/astro/images/layout-right.svg';

export function SaveTimeByChoosingSection() {
  return (
    <section className='flex flex-col items-center justify-center gap-8 px-5 pt-18 pb-9 sm:gap-14 sm:px-14 lg:gap-18 lg:px-18'>
      <div className='flex max-w-[1296px] flex-col items-center justify-end gap-8 sm:gap-14 lg:flex-row lg:gap-18'>
        <div className='flex w-full max-w-[612px] flex-[3_auto] flex-col gap-8'>
          <div className='flex flex-col items-start gap-4'>
            <div className='flex items-center justify-center gap-3 rounded-full bg-azure-455/10 px-4 py-[5px]'>
              <div className='rotate-90 text-[20px] leading-[27px] font-[500]'>
                👆
              </div>
              <div className='text-[12px] leading-[16px] font-[600] text-neutral-945 lg:text-[16px] lg:leading-[21.6px]'>
                SAVE
              </div>
            </div>

            <h2 className='text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px] lg:text-[44px] lg:leading-[47px]'>
              <span className='text-azure-595'>Save time</span> by choosing
              which sections to listen to
            </h2>
          </div>
          <div className='flex flex-[2_auto] flex-col items-start gap-8 self-stretch p-0 sm:gap-6 lg:self-auto'>
            <div className='flex items-start gap-4'>
              <img alt='Icon' loading='lazy' src={layoutRightSvg} />
              <div className='text-[16px] leading-[21px] text-neutral-840 sm:text-[24px] sm:leading-[32px] sm:font-[400] lg:text-[20px] lg:leading-[27px] lg:font-[500]'>
                Listening allows you to select which sections of a paper to
                listen to.
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Icon' loading='lazy' src={frame6Svg} />
              <div className='text-[16px] leading-[21px] text-neutral-840 sm:text-[24px] sm:leading-[32px] sm:font-[400] lg:text-[20px] lg:leading-[27px] lg:font-[500]'>
                Want to only listen to the abstract? Or skip to the results
                first? You can do that!
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Icon' loading='lazy' src={frame7Svg} />
              <div className='text-[16px] leading-[21px] text-neutral-840 sm:text-[24px] sm:leading-[32px] sm:font-[400] lg:text-[20px] lg:leading-[27px] lg:font-[500]'>
                Of course, you can also listen to entire papers from top to
                bottom.
              </div>
            </div>
          </div>
        </div>
        <img
          alt='Frame'
          className='block min-w-[250px] flex-[2_auto] object-scale-down [@media(max-width:767px)]:max-h-[500px]'
          loading='eager'
          src={frame1362789762Png}
        />
      </div>
    </section>
  );
}
